<!-- 延滞利息照会 -->
<mat-card appearance="outlined" class="cur-card">
    <mat-card-header>
      <mat-card-title>延滞利息照会</mat-card-title>
      <div>
        <mat-icon>contact_page</mat-icon>
      </div>
    </mat-card-header>
    <app-overdue-interest-list *ngIf="displayFlg" [interestList]="interestList"></app-overdue-interest-list>
  </mat-card>